'use client';

import { ToolCards } from '@/components/ToolCards';

interface InnerLinkProps {
  translations?: {
    title: string;
    toolCards?: {
      namespace?: string;
    };
  };
}

export default function InnerLink({ translations }: InnerLinkProps) {
  // 使用translations如果存在，否则使用默认值
  const title = translations?.title || 'Explore more tools';

  return (
    <section className='w-full py-12 lg:py-20'>
      <div className='flex w-full flex-col items-center justify-center'>
        <h2 className='mb-[1.88rem] text-center text-2xl font-semibold text-gray-800 md:mb-14 md:text-[44px]'>
          {title}
        </h2>
        <ToolCards translations={translations?.toolCards} />
      </div>
    </section>
  );
}
